import {
    Alert,
    Box,
    Button,
    CardContent, Grid,
    Table, TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getExpenseDetail, getExpensePaidDetail} from "../expense.api";
import {RootState} from "../../../store";
import moment from "moment";
import {
    CheckCircleOutline,
    DeleteForever,
    Edit,
    HighlightOffOutlined,
    PauseCircleFilledOutlined
} from "@mui/icons-material";
import ExpenseDetailAttachmentItem from "./ExpenseDetailAttachmentItem";
import ImagePreview from "../../../shared/ImagePreview";
import {BillingStatus} from "../expense.interface";

export default function ExpensePaidDetail(props: {
    id: string | null,
    onClose: any,
    onApprove: any,
    onPay: any,
    onReject: any,
    onEdit?: any,
    onDelete?: any,
    isMiniList?: boolean,
    status?: BillingStatus,
}) {

    const dispatch = useDispatch<any>()

    const {dataDetail} = useSelector((state: RootState) => state.expense)

    const [imageSelectedIndex, setImageSelectedIndex] = useState<number | null>(null)

    useEffect(() => {
        if (props.id) {
            dispatch(getExpensePaidDetail(props.id))
        }
    }, [dispatch])

    if (dataDetail === null) {
        return null
    }

    return (
        <Box display={"flex"} flexDirection={"column"} gap={3}>
            <Box>
                <Typography variant="body1"
                            sx={{opacity: 0.5}}>Invoice Number</Typography>
                <Typography variant="h6">{dataDetail?.invoiceNumber}</Typography>
            </Box>
            <Box sx={{
                borderRadius: '20px',
                backgroundColor: '#ffffff'
            }}>
                <CardContent>
                    <TableContainer sx={{maxHeight: 400}}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Created Date</TableCell>
                                    <TableCell>Fielder</TableCell>
                                    <TableCell>Notes</TableCell>
                                    <TableCell>Amount</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {dataDetail?.billings?.map((data, index) => (
                                    <TableRow key={`mileage-${index}`} className="hover">
                                        <TableCell>{data.createdDateString || '-'}</TableCell>
                                        <TableCell>{data?.fielder || '-'}</TableCell>
                                        <TableCell>{data.notes}</TableCell>
                                        <TableCell>$ {data.amount}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box mt={2}>
                        <Alert icon={false} severity="info" style={{borderRadius: '10px'}} sx={{
                            //MuiAlert-message
                            '& .MuiAlert-message': {
                                display: 'flex',
                                width: '100%',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }
                        }}>
                            <Grid display={'flex'} width={'100%'}>
                                <Typography fontWeight={600} color={'#0b75bb'} display={'flex'} flexGrow={1}>
                                    Total Payment
                                </Typography>
                                <Typography fontWeight={600} color={'#0b75bb'}>
                                    $ {dataDetail?.billings?.reduce((a, b) => a + b.amount, 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </Typography>
                            </Grid>
                        </Alert>
                    </Box>
                </CardContent>
            </Box>
            <Box>
                <Typography variant="body1"
                            sx={{opacity: 0.5}}>Notes</Typography>
                <Typography variant="body1">{dataDetail?.notes}</Typography>
            </Box>
            <Box>
                <Typography variant="body1" fontWeight={"bold"}>Attachment</Typography>
                {imageSelectedIndex !== null && (
                    <ImagePreview
                        name={dataDetail.attachments[imageSelectedIndex].fileName}
                        src={dataDetail.attachments[imageSelectedIndex].filePath}
                        isOpen={imageSelectedIndex !== null}
                        onClose={() => setImageSelectedIndex(null)}
                        onLeft={imageSelectedIndex > 0 ? () => setImageSelectedIndex(imageSelectedIndex - 1) : null}
                        onRight={imageSelectedIndex < (dataDetail.attachments.length - 1) ? () => setImageSelectedIndex(imageSelectedIndex + 1) : null}
                    />
                )}
                <Box display={"flex"} gap={1} flexWrap={"wrap"}>
                    {dataDetail.attachments.map((attachment, index) => (
                        <ExpenseDetailAttachmentItem key={index} name={attachment.fileName} path={attachment.filePath}
                                                     onClick={() => setImageSelectedIndex(index)}/>
                    ))}
                </Box>
            </Box>
            <Box display={"flex"} justifyContent={"space-between"}>
                <Button variant="contained" color="secondary" onClick={props.onClose}>Cancel</Button>
                {/*{*/}
                {/*    props?.isMiniList ? (*/}
                {/*        <Box display={"flex"} gap={1}>*/}
                {/*            <Button startIcon={<Edit/>} variant="contained" color="primary" onClick={props?.onEdit}>Edit</Button>*/}
                {/*            <Button startIcon={<DeleteForever/>} variant="contained" color="error" onClick={props?.onDelete}>Delete</Button>*/}
                {/*        </Box>*/}
                {/*    ) : (*/}
                {/*        <>*/}
                {/*            {dataDetail.status === 0 && (*/}
                {/*                <Box display={"flex"} gap={1}>*/}
                {/*                    <Button variant="contained" color="error" onClick={props.onReject}>Reject</Button>*/}
                {/*                    {props.status === BillingStatus.Approved && <Button variant="contained" color="primary" onClick={props.onPay}>Pay</Button>}*/}
                {/*                    {props.status === BillingStatus.Pending && <Button variant="contained" color="primary" onClick={props.onApprove}>Approved</Button>}*/}
                {/*                </Box>*/}
                {/*            )}*/}
                {/*        </>*/}
                {/*    )*/}
                {/*}*/}
            </Box>
        </Box>
    )
}